module.exports = __webpack_public_path__ + "static/media/nenewhite.954abfa2.jpg";